// src/Components/pages/AdminSettings.js
import React from 'react';
import './AdminPages.css';

const AdminSettings = ({ user }) => {
  return (
    <div className="admin-page">
      <h1 className="page-title">Settings</h1>
      <p className="page-description">Configure system settings and preferences</p>
      
      <div className="settings-section">
        <h3>General Settings</h3>
        <div className="settings-card">
          <label>
            <input type="checkbox" defaultChecked /> Enable email notifications
          </label>
          <label>
            <input type="checkbox" defaultChecked /> Enable maintenance mode
          </label>
          <label>
            <input type="checkbox" /> Enable two-factor authentication
          </label>
        </div>
      </div>
      
      <div className="settings-section">
        <h3>User Profile</h3>
        <div className="settings-card">
          <div className="profile-info">
            <p><strong>Name:</strong> {user?.name || 'Admin User'}</p>
            <p><strong>Email:</strong> {user?.email || 'admin@example.com'}</p>
            <p><strong>Role:</strong> {user?.role || 'Administrator'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;